var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('img',{attrs:{"src":_vm.imgUrl}}),_c('div',[_c('p',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.errorText))]),_c('p',{staticClass:"error-desc"},[_vm._v(_vm._s(_vm.errorDesc))]),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }